import actions from '../../../../redux/actions/ui/dataImport/strategies/purchaseOrderStrategy.js'
import BaseStrategy from '../BaseStrategy.js'
import ReconcileForm from './ReconcileForm.js'
import EditForm from './EditForm.js'
import {getNounsFromValue} from '../../../../common/tokenizeOptions.js'

export default function PurchaseOrderStrategy(props) {
  return (
    <BaseStrategy
      {...props}
      actions={actions}
      EditForm={EditForm}
      ReconcileForm={ReconcileForm}
    />
  )
}

PurchaseOrderStrategy.title = actions.title
const option = {
  value: 'create_purchase_orders',
  display: 'Create Purchase Orders',
  category: 'purchase_orders',
  Component: PurchaseOrderStrategy,
}
option.nouns = getNounsFromValue(
  `${option.value} ${option.display} ${option.category}`,
)
PurchaseOrderStrategy.option = option
